var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Leaderboard-Mobile---Accordion-Positions",
    transform: "translate(-316 -378)",
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Leaderboard-and-BG",
    transform: "translate(0 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Leaderboard",
    transform: "translate(17 306)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Accordion-Ranks",
    transform: "translate(6 60)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Plus-Icon",
    transform: "translate(293 14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0c.518 0 .938.42.938.938l-.001 5.624h5.626a.937.937 0 110 1.875H8.436v5.626a.937.937 0 11-1.874 0l-.001-5.626H.937a.938.938 0 010-1.874l5.625-.001V.937C6.563.42 6.982 0 7.5 0z",
    id: "Combined-Shape"
  })))))))));
}
SvgPlusIcon.displayName = 'PlusIcon';
export default SvgPlusIcon;